import * as Actions from '../../actions/jobCard/type';

const initialState = {
  getJobcardListLoading: false,
  jobCardList: [],
  error: '',

  getJobcardByIdLoading: false,
  jobcardById: '',

  deleteJobcardLoading: false,
  deleteJobcardSuccess: '',

  addJobcardLoading: false,
  addJobcard: '',
  addJobcardError: '',

  slectedBayList: [],
  slectedBayListError: '',
  slectedBayListLoading: false,

  updateJobCard: '',
  updateJobCardError: '',
  updateJobCardLoading: false,
  confirmItemLoader: false,
  selectedJobCardData: null,
  getCommentsLoader: false,
  commentsLoader: false,
  commentsErr: '',
  commentData: {}, // LIST
  newComment: {},
  updatedComment: {},
  deletedComment: {},
  getMessageLoader: false,
  messages: [],
  messageLoader: false,
  newMessage: {},
  messageErr: null,
};

export const JobCardReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get job card listing
    case Actions.GET_JOB_CARD_LISTING_REQUEST:
      return {
        ...state,
        getJobcardListLoading: true,
      };
    case Actions.GET_JOB_CARD_LISTING_SUCCESS:
      return {
        ...state,
        getJobcardListLoading: false,
        jobCardList: action?.payload?.jobcards || [],
      };
    case Actions.GET_JOB_CARD_LISTING_FAIL:
      return {
        ...state,
        getJobcardListLoading: false,
        error: action.payload,
      };

    // Get job card By Id
    case Actions.GET_JOBCARD_BY_ID_REQUEST:
      return {
        ...state,
        getJobcardByIdLoading: true,
      };
    case Actions.GET_JOBCARD_BY_ID_SUCCESS:
      return {
        ...state,
        getJobcardByIdLoading: false,
        jobcardById: action?.payload?.data || '',
      };
    case Actions.GET_JOBCARD_BY_ID_FAIL:
      return {
        ...state,
        getJobcardByIdLoading: false,
        error: action.payload,
      };
    case Actions.CLEAR_GET_JOBCARD_BY_ID_STATE:
      return {
        ...state,
        jobcardById: '',
        getJobcardByIdLoading: false,
        error: '',
      };

    // Delete job card
    case Actions.DELETE_JOB_CARD_REQUEST:
      return {
        ...state,
        deleteJobcardLoading: true,
      };
    case Actions.DELETE_JOB_CARD_SUCCESS:
      const jobCardId = action?.id;
      let jobCardListData = state.jobCardList;
      if (jobCardId) {
        jobCardListData = jobCardListData.filter(
          (jobCard) => jobCard.id !== jobCardId,
        );
      }
      return {
        ...state,
        deleteJobcardLoading: false,
        deleteJobcardSuccess: action.payload,
        jobCardList: jobCardListData,
      };
    case Actions.DELETE_JOB_CARD_FAIL:
      return {
        ...state,
        deleteJobcardLoading: false,
        error: action.payload,
      };

    // Insert job card
    case Actions.ADD_JOB_CARD_REQUEST:
      return {
        ...state,
        addJobcardLoading: true,
        addJobcard: '',
        addJobcardError: '',
      };
    case Actions.ADD_JOB_CARD_SUCCESS:
      return {
        ...state,
        addJobcardLoading: false,
        addJobcard: action.payload || '',
      };
    case Actions.ADD_JOB_CARD_FAIL:
      return {
        ...state,
        addJobcardLoading: false,
        addJobcardError: action.payload,
      };

    // Get job card Bay listing
    case Actions.GET_JOB_CARD_BAY_LISTING_REQUEST:
      return {
        ...state,
        slectedBayListLoading: true,
      };
    case Actions.GET_JOB_CARD_BAY_LISTING_SUCCESS:
      return {
        ...state,
        slectedBayListLoading: false,
        slectedBayList: action.payload ? action.payload.data : [],
      };
    case Actions.GET_JOB_CARD_BAY_LISTING_FAIL:
      return {
        ...state,
        slectedBayListLoading: false,
        slectedBayListError: action.payload,
      };

    // // Update job card
    // case Actions.UPDATE_JOB_CARD_REQUEST:
    //   return {
    //     ...state,
    //     updateJobCardLoading: true,
    //     updateJobCard: '',
    //     updateJobCardError: '',
    //   };
    // case Actions.UPDATE_JOB_CARD_SUCCESS:
    //   const jobData = action?.payload?.data;
    //   const jobCards = state.jobCardList;
    //   if (jobData?.id) {
    //     const indexOfJobCard = jobCards?.findIndex(
    //       (j) => Number(j.id) === jobData?.id,
    //     );
    //     jobCards[indexOfJobCard] = jobData;
    //   }
    //   return {
    //     ...state,
    //     updateJobCardLoading: false,
    //     updateJobCard: action.payload,
    //     jobCardList: [...jobCards],
    //   };
    // case Actions.UPDATE_JOB_CARD_FAIL:
    //   return {
    //     ...state,
    //     updateJobCardLoading: false,
    //     updateJobCardError: action.payload,
    //   };

    // Statuses Confirm of Parts, Labour, Supplies
    case Actions.CONFIRM_ITEM_STATUS_REQUEST:
      return {
        ...state,
        confirmItemLoader: true,
        updateJobCard: '',
        updateJobCardError: '',
      };
    case Actions.CONFIRM_ITEM_STATUS_SUCCESS:
      return {
        ...state,
        confirmItemLoader: false,
        updateJobCard: action.payload,
      };
    case Actions.CONFIRM_ITEM_STATUS_FAIL:
      return {
        ...state,
        confirmItemLoader: false,
        updateJobCardError: action.payload,
      };

    // // get all jobcards comments
    // case Actions.GET_ALL_COMMENTS_REQUEST:
    //   return {
    //     ...state,
    //     getCommentsLoader: true,
    //   };
    // case Actions.GET_ALL_COMMENTS_SUCCESS:
    //   return {
    //     ...state,
    //     getCommentsLoader: false,
    //     commentData: action.payload,
    //   };
    // case Actions.GET_ALL_COMMENTS_FAIL:
    //   return {
    //     ...state,
    //     getCommentsLoader: false,
    //     commentsErr: action.payload,
    //   };

    // to get updated list on jobboard and stop from moving
    case 'UPDATE_JOBCARD_LIST_OBJECT':
      const updatedJob = action?.jobCard;
      const jobCardsList = state.jobCardList;
      if (updatedJob?.id) {
        const indexOfNewJobCard = jobCardsList?.findIndex(
          (j) => Number(j.id) === updatedJob?.id,
        );
        if (indexOfNewJobCard > -1) {
          jobCardsList[indexOfNewJobCard] = updatedJob;
        }
      }
      return {
        ...state,
        jobCardList: [...jobCardsList],
      };

    // ==================== comments start =======================
    // // create jobcards comments
    // case Actions.CREATE_COMMENT_REQUEST:
    //   return {
    //     ...state,
    //     commentsLoader: true,
    //   };
    // case Actions.CREATE_COMMENT_SUCCESS:
    //   return {
    //     ...state,
    //     commentsLoader: false,
    //     newComment: action.payload,
    //   };
    // case Actions.CREATE_COMMENT_FAIL:
    //   return {
    //     ...state,
    //     commentsLoader: false,
    //     commentsErr: action.payload,
    //   };

    // update comments
    // case Actions.UPDATE_COMMENT_REQUEST:
    //   return {
    //     ...state,
    //     commentsLoader: true,
    //   };
    // case Actions.UPDATE_COMMENT_SUCCESS:
    //   return {
    //     ...state,
    //     commentsLoader: false,
    //     updatedComment: action.payload,
    //   };
    // case Actions.UPDATE_COMMENT_FAIL:
    //   return {
    //     ...state,
    //     commentsLoader: false,
    //     commentsErr: action.payload,
    //   };

    // delete comments
    // case Actions.DELETE_COMMENT_REQUEST:
    //   return {
    //     ...state,
    //     // commentsLoader: true,
    //   };
    // case Actions.DELETE_COMMENT_SUCCESS:
    //   return {
    //     ...state,
    //     // commentsLoader: false,
    //     deletedComment: action.payload,
    //   };
    // case Actions.DELETE_COMMENT_FAIL:
    //   return {
    //     ...state,
    //     // commentsLoader: false,
    //     commentsErr: action.payload,
    //   };
    // ==================== comments end =======================

    // ==================== replies start =======================
    // create relies to comments
    // case Actions.REPLY_TO_COMMENT_REQUEST:
    //   return {
    //     ...state,
    //     replyLoader: true,
    //   };
    // case Actions.REPLY_TO_COMMENT_SUCCESS:
    //   return {
    //     ...state,
    //     replyLoader: false,
    //     replyData: action.payload,
    //   };
    // case Actions.REPLY_TO_COMMENT_FAIL:
    //   return {
    //     ...state,
    //     replyLoader: false,
    //   };

    // // update relies
    // case Actions.UPDATE_COMMENT_REPLY_REQUEST:
    //   return {
    //     ...state,
    //     replyLoader: true,
    //   };
    // case Actions.UPDATE_COMMENT_REPLY_SUCCESS:
    //   return {
    //     ...state,
    //     replyLoader: false,
    //     replyData: action.payload,
    //   };
    // case Actions.UPDATE_COMMENT_REPLY_FAIL:
    //   return {
    //     ...state,
    //     replyLoader: false,
    //   };
    // // delete relies
    // case Actions.DELETE_COMMENT_REPLY_REQUEST:
    //   return {
    //     ...state,
    //     replyLoader: true,
    //   };
    // case Actions.DELETE_COMMENT_REPLY_SUCCESS:
    //   return {
    //     ...state,
    //     replyLoader: false,
    //   };
    // case Actions.DELETE_COMMENT_REPLY_FAIL:
    //   return {
    //     ...state,
    //     replyLoader: false,
    //   };
    // ======================= replies end ========================

    // ==================== messages start ========================
    // // getting all messages
    // case Actions.GET_ALL_MESSAGES_REQUEST:
    //   return {
    //     ...state,
    //     getMessageLoader: true,
    //   };
    // case Actions.GET_ALL_MESSAGES_SUCCESS:
    //   return {
    //     ...state,
    //     getMessageLoader: false,
    //     messages: action.payload,
    //   };
    // case Actions.GET_ALL_MESSAGES_FAIL:
    //   return {
    //     ...state,
    //     getMessageLoader: false,
    //     messageErr: action.payload,
    //   };
    // sending message against job card
    // case Actions.SEND_MESSAGE_REQUEST:
    //   return {
    //     ...state,
    //     messageLoader: true,
    //   };
    // case Actions.SEND_MESSAGE_SUCCESS:
    //   return {
    //     ...state,
    //     messageLoader: false,
    //     newMessage: action.payload,
    //   };
    // case Actions.SEND_MESSAGE_FAIL:
    //   return {
    //     ...state,
    //     messageLoader: false,
    //     messageErr: action.payload,
    //   };

    case Actions.CLEAR_NEW_REPLY_STATE:
      return {
        ...state,
        replyLoader: false,
        replyData: {},
      };
    case Actions.CLEAR_NEW_MESSAGE_STATE:
      return {
        ...state,
        newMessage: {},
        messageErr: '',
      };
    // ==================== messages end ========================

    case Actions.CLEAR_JOBCARD_STATES:
      return {
        ...state,
        getJobcardListLoading: false,
        error: '',

        deleteJobcardLoading: false,
        deleteJobcardSuccess: '',

        addJobcard: '',
        addJobcardError: '',
        addJobcardLoading: false,

        slectedBayListError: '',
        slectedBayListLoading: false,

        updateJobCard: '',
        updateJobCardError: '',
        updateJobCardLoading: false,
      };

    case Actions.SET_SELECTED_JOBCARD_DATA:
      return {
        ...state,
        selectedJobCardData: action.payload,
      };
    default:
      return state;
  }
};

export const jobCardLogsReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.GET_JOBCARD_LOGS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Actions.GET_JOBCARD_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        ...(action?.payload || ''),
      };
    case Actions.GET_JOBCARD_LOGS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case Actions.CLEAR_GET_JOBCARD_LOGS_STATE:
      return {
        ...state,
        loading: false,
        data: [],
      };
    default:
      return state;
  }
};
